import { FlowGetExternalDocumentPacketBlockSchema } from 'flow-schema';

import { GetExternalDocumentPacketFormFields } from './FormFields';
import { GetExternalDocumentPacketDocumentation } from './documentation';
import { type BlockConfigProps } from '../../types';

export const getExternalDocumentPacketConfig: BlockConfigProps = {
  nodeHandles: [{ type: 'target' }, { type: 'source' }],
  defaultLabelPrefix: 'externalDocumentPacket',
  defaultConfig: {
    orderId: '',
  },
  configFields: {
    schema: FlowGetExternalDocumentPacketBlockSchema.shape.config,
    FormFields: GetExternalDocumentPacketFormFields,
  },
  documentationMarkdown: GetExternalDocumentPacketDocumentation,
};
